import { EIcons } from '@/app/types/iconType'
import { Button, Icon } from '@/shared'

import style from './Data.module.scss'

interface IProps {
    pageInfo: string | null
    isFetchingAdmins: boolean
    setShowAddAdmin: (showAddAdmin: boolean) => void
}

export const Data = (props: IProps) => {
    const { pageInfo, isFetchingAdmins, setShowAddAdmin } = props
    return (
        <div className={style.container}>
            <div className={style.commonData}>
                <span className={style.admins}>Админы </span>
                <span className={style.specialists}>{pageInfo}</span>
            </div>
            <div className={style.actions}>
                <Button onClick={() => setShowAddAdmin(true)} disabled={isFetchingAdmins}>
                    <div>
                        <Icon iconName={EIcons.PLUS} color='#fff' />
                        <span>Добавить админа</span>
                    </div>
                </Button>
            </div>
        </div>
    )
}
